<div class="mmc-modal-wrapper questionnaire-modal">
    <div class="mmc-modal-header mmc_flex--container">
        <div class="mmc_flex__item--inherit mmc_flex__item--vcenter icon-cage mmc_just-content-center">
            <i class="material-icons">forum</i>
        </div>
        <div class="mmc_flex__item mmc_flex__item--vcenter">
            <span class="section-title">Questionnaire</span>
        </div>
        <div class="mmc_flex__item--inherit mmc_flex__item--vcenter close-icon-cage mmc_just-content-center">
            <button mat-button [mat-dialog-close]="true" tabindex="0"><i class="material-icons">close</i></button>
        </div>
    </div>

    <!-- Include the questionnaire component -->
    <div class="mmc-modal-body">
        <opt-questionnaire 
            [package]="package" 
            [facilitySummary]="facilitySummary" 
            [item]="item" 
            [booking]="booking"
            [isFullBookingView]="isFullBookingView" 
            [isReadOnly]="isReadOnly" 
            [data]="data" 
            [showButton]="showButton"
            (onSubmit)="onQuestionnaireSubmit($event)"
        >
        </opt-questionnaire>
    </div>

</div>